//import Index from '../Index'
import {check_login} from '@/helper/function'

export default [
    {
        path: '/report-error',
        name: 'report_error',
        beforeEnter: (to, from, next) => {
            check_login(to, from, next)
        },
        component: () => import('../Index.vue')
    }
]